import React, { useState } from 'react';
import axios from 'axios';
import '../css/navbar.css';
import Footer from './Footer';

function HomePage() {
    const [longUrl, setLongUrl] = useState('');
    const [shortUrl, setShortUrl] = useState('');
    const [error, setError] = useState('');
    const [isCopied, setIsCopied] = useState(false);
    const [shouldShake, setShouldShake] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!longUrl.trim()) {
            setShouldShake(true);
            return;
        }

        try {
            const username = localStorage.getItem('username') || '';
            const response = await axios.post(
                'https://urlshortener-serverside.onrender.com/api/links/shorten',
                { longUrl, creator: username },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true,
                }
            );

            if (response.data && response.data.shortUrl) {
                setShortUrl(response.data.shortUrl);
            } else {
                setError('Failed to generate a shortened URL.');
            }

            setLongUrl('');
        } catch (err) {
            console.error('Failed to shorten URL:', err);
            setError('Failed to shorten URL. Please try again.');
        }
    };

    const copyUrl = () => {
        if (shortUrl) {
            const fullUrl = `${window.location.origin}/${shortUrl}`;
            navigator.clipboard.writeText(fullUrl)
                .then(() => {
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 2000);
                })
                .catch((error) => {
                    console.error('Failed to copy URL to clipboard:', error);
                });
        }
    };
    

    return (
        <div
            style={{
                background: '#0f172a',
                color: 'white',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                padding: '1rem',
            }}
        >
            {/* Header */}
            <header
                style={{
                    textAlign: 'center',
                    marginBottom: '2rem',
                }}
            >
                <h1
                    style={{
                        fontSize: '2.5rem',
                        color: '#e0f2fe',
                        marginBottom: '1rem',
                    }}
                >
                    BlinkURL
                </h1>
                <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                    A smarter way to share your links in 2025.
                </p>
            </header>

            {/* Hero Section */}
            <main
                style={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <form
                    onSubmit={handleSubmit}
                    style={{
                        width: '100%',
                        maxWidth: '400px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1rem',
                        padding: '1rem',
                        background: 'rgba(255, 255, 255, 0.1)',
                        borderRadius: '1rem',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                    }}
                >
                    <input
                        id="url-input"
                        type="url"
                        placeholder="Paste your long URL here..."
                        required
                        value={longUrl}
                        onChange={(e) => setLongUrl(e.target.value)}
                        className={shouldShake ? 'shake' : ''}
                        onAnimationEnd={() => setShouldShake(false)}
                        style={{
                            width: '100%',
                            padding: '1rem',
                            border: 'none',
                            borderRadius: '0.5rem',
                            background: 'rgba(255, 255, 255, 0.05)',
                            color: 'white',
                            fontSize: '1rem',
                        }}
                    />
                    <button
                        type="submit"
                        style={{
                            width: '100%',
                            padding: '0.75rem',
                            border: 'none',
                            borderRadius: '0.5rem',
                            background: '#6366f1',
                            color: 'white',
                            fontSize: '1.1rem',
                            fontWeight: '600',
                        }}
                    >
                        Shorten
                    </button>
                </form>
                {error && (
                    <p
                        className="text-danger"
                        style={{
                            color: '#ff6b6b',
                            marginTop: '1rem',
                            textAlign: 'center',
                        }}
                    >
                        {error}
                    </p>
                )}
                {shortUrl && (
                    <div
                        className="result"
                        style={{
                            marginTop: '1rem',
                            padding: '1rem',
                            background: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '0.5rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: '400px',
                        }}
                    >
                        <a
                            href={`${window.location.origin}/${shortUrl}`}
                            className="short-url"
                            style={{
                                color: '#38bdf8',
                                textDecoration: 'none',
                                flex: '1',
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {`${window.location.origin}/${shortUrl}`}
                        </a>

                        <div
                            className="copy-btn"
                            onClick={copyUrl}
                            style={{
                                background: '#38bdf8',
                                padding: '0.5rem 1rem',
                                borderRadius: '0.5rem',
                                cursor: 'pointer',
                                color: 'white',
                                fontWeight: '600',
                                marginLeft: '0.5rem',
                            }}
                        >
                            {isCopied ? 'Copied!' : 'Copy'}
                        </div>
                    </div>
                )}
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default HomePage;
